module.exports = __webpack_public_path__ + "img/puberty-decal-25.7d21ba30.png";